import { PRIVATE_ROUTES } from '@constants/routes';

export const shouldIgnoreLayout = (route: string): boolean =>
  !PRIVATE_ROUTES.some(
    (r: string) => route.split('/')[1].split('?')[0] === r.split('/')[1]
  );
